import OSS from 'ali-oss';
// import { IMAGE_REGEX, FILE_REGEX } from '@/utils/constants';
// import { randomNum } from '@/utils';

const client = new OSS({
  accessKeyId: 'LTAI5tPTb2NU9WT9yjQbtnjf',
  accessKeySecret: 'ibng4JGxZJVKejxPOiJgR4NylK8ADZ',
  // region表示您申请OSS服务所在的地域，例如oss-cn-hangzhou。
  region: 'oss-cn-shenzhen',
  bucket: 'dfosspic01',
});

export const isImageType = file => {
  const { type, name } = file;
  const arr = name.split('.');
  const lastName = arr[arr.length - 1];
  const IMAGE_REGEX =  /(jpg|jpeg|png|gif)/;
  if (type.indexOf('image') > -1) {
    if (!IMAGE_REGEX.test(lastName.toLowerCase())) {
      // message.warn('目前只支持jpg、png、gif格式图片~');
      return false;
    }
  } else {
    // message.warn('目前只支持jpg、png、gif格式图片~');
    return false;
  }
  return true;
};

export const isFileType = file => {
  const { type, name } = file;
  const arr = name.split('.');
  const lastName = arr[arr.length - 1];
  const FILE_REGEX = /(pdf|xls|xlsx|doc|docx)/;
  if (type.indexOf('application') > -1) {
    if (!FILE_REGEX.test(lastName.toLowerCase())) {
      // message.warn('目前只支持pdf、xls、xlsx、doc、docx格式文件~');
      return false;
    }
  } else {
    // message.warn('目前只支持pdf、xls、xlsx、doc、docx格式文件~');
    return false;
  }
  return true;
};

export default (file,ossUrl) => {
  console.log(file)
  const { name } = file;
  const lastLocation =  name.lastIndexOf('.');
  let upName = ''
  if(lastLocation!=-1){
    const firstName = name.substring(0,lastLocation)
    const lastName =  name.substr(lastLocation)
    upName = `${firstName}_${new Date().getTime()}${lastName}`
  }else{
    upName = `${file.lastModified}_${name}`
  }
  const arr = name.split('.');
  const picUrl = ossUrl||'pic/share';
  // if (size / 1048576 > 2) {
  //   message.warn('上传的文件不能超过2M');
  //   return Promise.resolve(false);
  // }
// 
console.log(arr)
// console.log(arr[arr.length - 1])
  return new Promise(resolve => {
    client.multipartUpload(`/dfcloud/${picUrl}/${upName}`, file).then(res => {
      resolve(res);
    }).catch((err ) => {
      console.log(err,'错误')
      resolve(false);
    });
  });
};
export const base64ToFile = (dataUrl,  name)=>{
  var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  console.log(mime)
  return new File([u8arr], name+ '.jpg' ,{ type: "image/jpg" });
};

// export async function UpFile (file) {
//   // const { type, size } = file;
//   const url = await client.multipartUpload(`/www/user_pic/file${randomNum()}_${Date.now()}_${file.name}`, file);
//   const mesg = {
//     url: url,
//     uid: file.uid,
//   };
//   return mesg;
// };


// 网络图片转成base64

